import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/themeThree/headerTextBg.png'


const _hoisted_1 = { class: "popupContainer" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "groupName" }
const _hoisted_4 = { class: "gameCount" }
const _hoisted_5 = { class: "countText" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "bottomText" }
const _hoisted_9 = { class: "showAllText" }

import { ref, computed, onMounted, onBeforeUnmount, PropType } from 'vue'
import GameCard from './components/gameCard.vue'
import { useUserStore } from '@/stores/user'
import { GameData } from '@/view/game/supportScript';
import { playClickSound } from '@/utils/media';

export default /*@__PURE__*/_defineComponent({
  __name: 'gamePopup',
  props: {
    dataSet: {
        type: Object as PropType<GameData>,
        required: true
    }
},
  emits: ['update:show', 'update:showPopover', 'open', 'close', 'goToProfile', 'selectGroup', 'loadMoreGame', 'goToDeposit', 'goToPlayGame', 'openRegisterPopup','collapseGames'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const popoverRef = ref<HTMLElement | null>(null)
const triggerRef = ref<HTMLElement | null>(null)
const props = __props

const show = computed({
    get: () => props.dataSet.show,
    set: (val) => emits('update:show', val)
})

const showPopover = computed({
    get: () => props.dataSet.showPopover,
    set: (val) => emits('update:showPopover', val)
})
const emits = __emit
const displayCount = computed(() => props.dataSet?.gameList.length < 12 ? props.dataSet?.gameList.length : 12);
const selectedGroup = computed<any>(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item
})
const activeItemIcon = computed(() => {
    const item = props.dataSet.groupList.find((i: any) => i.id == props.dataSet.activeItem);
    return item?.icon;
});

const open = (id: number | string) => {
    emits('open', id)
}

const loadMoreGame = () => {
    emits('loadMoreGame')
}
const collapseGames = () => {
    emits('collapseGames')
}

const handleClickOutside = (event: MouseEvent) => {
    const popoverEl = popoverRef.value
    const triggerEl = triggerRef.value
    if (
        popoverEl &&
        !popoverEl.contains(event.target as Node) &&
        triggerEl &&
        !triggerEl.contains(event.target as Node)
    ) {
        showPopover.value = false
    }
}
const goToPlayGame = (ID: any, makerID: any, favorite: number, favId: any) => {
    let data = {
        id: ID,
        makerId: makerID,
        isFavorite: favorite,
        favId: favId
    }
    emits('goToPlayGame', data)
}
const nextPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    // if (currentPage.value < totalPages.value - 1) {
        playClickSound()
        // slideDirection.value = 'right'
        // currentPage.value++
    // }
}

const prevPage = () => {
    if (process.env.VUE_APP_PREVIEW_MODE == 'true') return
    // if (currentPage.value > 0) {
        playClickSound()
        // slideDirection.value = 'left'
        // currentPage.value--
    // }
}

__expose({
    open,
})
onMounted(() => {
    document.addEventListener('click', handleClickOutside)
    console.log('selectedGroup', selectedGroup.value);

})

onBeforeUnmount(() => {
    document.removeEventListener('click', handleClickOutside)
})

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("img", {
      src: _imports_0,
      alt: "",
      width: "80%"
    }, null, -1)),
    _createVNode(_component_van_row, {
      class: "titleHead",
      justify: "space-between",
      style: {"margin-bottom":"10px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "15",
          class: "group_col"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              src: activeItemIcon.value,
              alt: ""
            }, null, 8, _hoisted_2),
            _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t(selectedGroup.value.name)), 1),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "slashLine" }, null, -1)),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.dataSet.gameCount), 1),
              _createElementVNode("div", null, _toDisplayString(_ctx.$t('message.all')), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, {
          span: "8",
          class: "group_col_right"
        })
      ]),
      _: 1
    }),
    _createVNode(_component_van_row, { class: "game_container" }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, {
          span: "24",
          class: "right_container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_van_row, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.dataSet?.gameList, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_col, {
                    span: "6",
                    class: "game_item",
                    key: index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(GameCard, {
                        gameImage: item.customIcon,
                        onClickGameCard: ($event: any) => (goToPlayGame(item.activeGameId, item.gameMakerId, item.isFavorite, item.id)),
                        gameTypeId: item.id,
                        gameIsFavorite: item.isFavorite
                      }, null, 8, ["gameImage", "onClickGameCard", "gameTypeId", "gameIsFavorite"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            (__props.dataSet?.gameList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (__props.dataSet.activeItem != 'fav')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('game.moreGameText', {
                            displayCount: __props.dataSet?.gameList.length, gameCount:
                            __props.dataSet.gameCount })), 1),
                        _createElementVNode("div", _hoisted_9, [
                          ( __props.dataSet?.showLoadMore)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 0,
                                onClick: loadMoreGame
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('game.showAll')), 1),
                                _createVNode(_component_van_icon, {
                                  name: "arrow-down",
                                  class: "showIcon"
                                })
                              ]))
                            : _createCommentVNode("", true),
                          (__props.dataSet?.gameList.length === __props.dataSet.gameCount)
                            ? (_openBlock(), _createElementBlock("div", {
                                key: 1,
                                onClick: collapseGames
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('game.collect')), 1),
                                _createVNode(_component_van_icon, {
                                  name: "arrow-up",
                                  class: "showIcon"
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})